import { StorageService } from '@empathy/storage-service';
import { container } from '../../../container';
import { DEPENDENCIES, STORAGE } from '../../../container/dependencies.const';
import { EmpathyXConfig } from '../../../models';
import { normalizeString } from '../../../utils';
import { GETTERS_KEYS } from '../../store.const';
import { HISTORY_ACTIONS_KEYS, HISTORY_MUTATIONS_KEYS, historyItemStrategy, SESSION_QUERY_HISTORY_KEY } from '../history.const';
import { HistoryAction, HistoryContext } from '../history.interfaces';
import { getHistoryItemStrategy } from '../history.utils';

export class AddSessionQueryHistoryAction implements HistoryAction {
  protected storageService: StorageService;

  actions = {
    [HISTORY_ACTIONS_KEYS.addQueryToSessionQueryHistory]: ({ commit, rootGetters, rootState }: HistoryContext, query: string): any => {
      const { history: { sessionQueryHistory: config } }: EmpathyXConfig = rootGetters[GETTERS_KEYS.config.config];
      const sessionQueryHistory = this.generateNewHistory(rootState.history.sessionQueryHistory, query.trim());
      sessionQueryHistory.splice(config.size);
      this.saveSessionHistoryToStorage(sessionQueryHistory, config.ttl);
      commit(HISTORY_MUTATIONS_KEYS.setSessionQueryHistory, sessionQueryHistory);
    }
  };

  protected generateNewHistory(oldHistory: string[], newTerm: string): string[] {
    const normalizedNewTerm = normalizeString(newTerm);
    const currentHistoryItemStrategy = getHistoryItemStrategy(normalizedNewTerm, normalizeString(oldHistory[0]));
    const newHistory = oldHistory.filter((historyItem, index) => index === 0 || normalizeString(historyItem) !== normalizedNewTerm);

    if (currentHistoryItemStrategy === historyItemStrategy.add) {
      newHistory.unshift(newTerm);
    } else if (currentHistoryItemStrategy === historyItemStrategy.replace) {
      newHistory[0] = newTerm;
    }
    return newHistory;
  }

  protected saveSessionHistoryToStorage(sessionHistory: string[], ttl: number) {
    this.storageService = this.storageService ?? container.getNamed<StorageService>(DEPENDENCIES.StorageService, STORAGE.Local);
    this.storageService.setItem(SESSION_QUERY_HISTORY_KEY, sessionHistory, ttl);
  }
}
